const createGeometry = (coordinates) => {    
    if (coordinates.length > 1) {
        return {
            "type": "GeometryCollection",
            "geometries": coordinates.map(c => {
                return {
                    "type": "Polygon",
                    "coordinates": c
                }
            })
        };
    } else {
        return {
            "type": "Polygon",
            "coordinates": coordinates[0],
        };
    }
}

export const generateFeatures = (id, feature, type, color = null, districtId = null) => {
    // Kontrollera att feature har geometry och coordinates
    if (!feature || !feature.geometry || !feature.geometry.coordinates) {
        console.warn('[generateFeatures] Feature saknar geometry eller coordinates:', feature);
        return null;
    }
    
    return {
        "type": "Feature",
        "id": id,
        "geometry": feature.geometry.type === 'Point' ? feature.geometry : createGeometry(feature.geometry.coordinates),
        "properties": {
            ...feature.properties,
            "type": type, 
            "name": feature.properties?.name,
            "color": color || feature.properties?.color,
            "districtId": districtId || id
        }
    };
};

export const convertToGeojson = (json, id, type) => {
    
    const features = [];
    json.features.forEach(feature => {
        features.push(generateFeatures(id, feature, type));
    });
    
    return {
        type: "FeatureCollection",
        features
    };
};